import React, { useState, useEffect } from 'react';
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";

const AboutUs = () => {
    const { t } = useTranslation();
    const isSSR = typeof window === 'undefined';
    const [isMobile, setIsMobile] = useState(!isSSR && window.innerWidth <= 768);

    const handleWindowSizeChange = () => {
        setIsMobile(!isSSR && window.innerWidth <= 768);
    };

    useEffect(() => {
        if (!isSSR) {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
        }
    }, [isSSR]); // Re-run effect when isSSR changes

    return (
        <>
            <section className="bg-dark multi-activity about-us hero-bg position-relative section-pdn pt-8 ">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                        <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                        <Trans>Encourage Employee <br/>Well-Being for People <br/>Sustainability</Trans>
                        </h1>
                        <p className="hero-para font-weight-semibold no-br">
                        <Trans>Uplift Physical, Mental, and Financial Well-being through our solutions to provide a sustainable work culture for your employees.</Trans>
                        </p>
                        <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative pl-0 pr-0 about-pattern-vfit">
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                        <div className="container custom_container home-bg-2 brd22 mb-5 abtus-mid-box">
                            <p className="abtus-mid"><Trans>Our holistic approach to corporate well-being provides you <br/>with the tools to foster a productive & sustainable work culture for <br/>your employees.</Trans></p>
                        </div>
                        <h2 className="font-weight-semibold section-heading text-center no-br">
                            <Trans>Our Journey</Trans>
                        </h2>
                        <div className="container custom_container home-bg-2 brd22 mb-5 abtus-mid-box">

                            {isMobile ? (
                                <img src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1723113191/VantageFit/2024/about-us-phone-english.webp`)} alt="about us timeline image mobile view" />
                            ) : (
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1723113057/VantageFit/2024/about-us-desktop.webp`)} alt="about us timeline image" />
                            )}
                        </div>
                        <h2 className="section-heading text-light text-center">
                            <Trans>Global Presence</Trans>
                        </h2>
                        <div className="new-worldmap-img">
                            <div className="d-flex justify-content-center align-items-center loc-img-wrapper m-d-block">
                                <div className="img-1">
                                    <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593056/VantageFit/2023/usa-contact_us_page.webp" />
                                </div>
                                <div className="img-2">
                                    <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593051/VantageFit/2023/australia-contact_us_page.webp" />
                                </div>
                                <div className="img-3">
                                    <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593052/VantageFit/2023/india-contact_us_page.webp" />
                                </div>
                                <div className="img-4">
                                    <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593051/VantageFit/2023/canada-contact_us_page.webp" />
                                </div>
                                <div className="img-5">
                                    <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593052/VantageFit/2023/netherlands-contact_us_page.webp" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="bottom-feat-cta position-relative section-pdn-1 feat_testi brad0">
                <div className="container custom_container">
                    <div className="review-grp">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="review-box">
                                    <div className="rvw-box1">
                                        <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1709532538/VantageFit/2023/landing-page/apple.png" alt="apple icon" width="29" height="37"/>
                                        <p>App Store</p>
                                    </div>
                                    <div className="rvw-box2">
                                        <div className="mr-2">4.3</div>
                                        <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1709532539/VantageFit/2023/landing-page/Star.svg" alt="star icon" width="30" height="29"/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="review-box">
                                    <div className="rvw-box1">
                                        <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1709532539/VantageFit/2023/landing-page/Google_play.png" alt="Google Play icon" width="33" height="37"/>
                                        <p>Google Play</p>
                                    </div>
                                    <div className="rvw-box2">
                                        <div className="mr-2">4.5</div>
                                        <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1709532539/VantageFit/2023/landing-page/Star.svg" alt="star icon" width="30" height="29"/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="review-box">
                                    <div className="rvw-box1">
                                        <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1709532539/VantageFit/2023/landing-page/g2.png" alt="G2 icon" width="36" height="37"/>
                                        <p>G2</p>
                                    </div>
                                    <div className="rvw-box2">
                                        <div className="mr-2">4.6</div>
                                        <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1709532539/VantageFit/2023/landing-page/Star.svg" alt="star icon" width="30" height="29"/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="review-box">
                                    <div className="rvw-box1">
                                        <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1709532539/VantageFit/2023/landing-page/captera.png" alt="Capterra icon" width="37" height="37"/>
                                        <p>Capterra</p>
                                    </div>
                                    <div className="rvw-box2">
                                        <div className="mr-2">4.3</div>
                                        <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1709532539/VantageFit/2023/landing-page/Star.svg" alt="star icon" width="30" height="29"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container custom_container d-flex justify-content-start align-items-center m-d-block  pt-8">
                    <div className="col-12">
                        <h2 className="font-weight-semibold section-heading text-center no-br mb-5">
                            <Trans>Start your wellness journey today!</Trans>
                        </h2>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

export default AboutUs;
